import { memo, useCallback } from 'react'

import { Divider, SvgIcon } from '@mui/material'
import { OrgTeam } from '@nativewaves/nw-cloud-sdk/org'
import { PlugDisconnected } from 'emotion-icons/fluentui-system-filled'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { MenuItemConfirm, MenuItemCopyId } from '@shared/components/MaterialUIEnhancements/Menu/MenuItem'
import { RowActionsProps } from '@shared/components/Table'
import { useTeamDeleteMutation } from 'hooks/mutations/org/Team'

const RowActionsRaw = ({ row, onClose }: RowActionsProps<OrgTeam>) => {
  const { t } = useTranslation(['common', 'domain', 'entity'])
  const { enqueueSnackbar } = useSnackbar()

  const { mutate: deleteTeam } = useTeamDeleteMutation()

  const handleDeleteAvcTask = useCallback(() => {
    onClose()

    deleteTeam(
      { teamId: row.original.id },
      {
        onSuccess: () =>
          enqueueSnackbar(t('domain:My.Organization.nameDelete', { name: row.original.name }), {
            variant: 'success',
          }),
      },
    )
  }, [onClose, deleteTeam, row.original.id, row.original.name, enqueueSnackbar, t])

  return (
    <>
      <MenuItemCopyId onSuccess={onClose} id={row.original.id} />
      <Divider component="li" />
      <MenuItemConfirm
        onConfirm={handleDeleteAvcTask}
        staticLabel={t('domain:Organization.deleteTeam')}
        startIcon={
          <SvgIcon color="error">
            <PlugDisconnected />
          </SvgIcon>
        }
        ConfirmTypographyProps={{ color: 'error' }}
      />
    </>
  )
}

export const RowActions = memo(RowActionsRaw)
